import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import useAccessToken from '../../hooks/AccessToken';
import Swal from 'sweetalert2';
import { useGoogleAccountStore } from '../../stores/GoogleAccount';
import { getProfileAccountByToken, setCodeGoogleCalendar, setVerifyGoogleCalendar } from '../../api/GoogleCalendar';
import { KTSVG } from '../../_metronic/helpers/components/KTSVG';
import BtnSignInAs from './BtnSignInAs';
import BtnGoogleLogin from './BtnGoogleLogin';
import useUser from '../../hooks/User';

interface GoogleLoginComponentProps {
    mutate: () => void
}

const GoogleLoginComponent = ({ mutate }: GoogleLoginComponentProps) => {
    const token = useAccessToken()
    const { setGoogleAccount, setIsLoadingGoogleAccount } = useGoogleAccountStore()
    const user = useUser()

    const login = useGoogleLogin({
        flow: 'auth-code',
        scope: 'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events openid email profile',

        onSuccess: async (tokenResponse) => {
            try {
                setIsLoadingGoogleAccount(true)
                const responseToken = await setCodeGoogleCalendar(tokenResponse.code)
                if (responseToken) {
                    const data = await responseToken;
                    await setVerifyGoogleCalendar(data, token)
                    const profile = await getProfileAccountByToken(token)
                    setGoogleAccount(profile.data)
                    mutate()
                }

            } catch (error) {
                console.log(error, 'error')
            } finally {
                setIsLoadingGoogleAccount(false)
            }
        },
        onError: error => {
            console.log(error, 'error')
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        }
    })

    return (
        <>
            {user?.data?.sync_google_calendar ? <BtnSignInAs login={login} mutate={mutate} /> : <BtnGoogleLogin login={login} />}
        </>
    );
};

export default GoogleLoginComponent;

